import axiosInstance from '../axiosInterceptor/axiosInstance'

const getOrgClubs = async (orgId) => {
  const response = await axiosInstance.get(`v1/orgs/${orgId}/clubs`)
  return response?.data
}

export default getOrgClubs
